/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If you would like to propose
 * a change to this component, please reach out to a
 * frontend engineer.
 *
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import classnames from 'classnames';

import styles from './spacer.scss';

export enum SpacerSize {
  XS, // 4px
  SM, // 8px
  MS, // 12px
  MD, // 16px
  LG, // 24px
  XL, // 32px
  XXL, // 64px
}

type SpacerProps = React.HTMLAttributes<HTMLDivElement> & {
  above?: SpacerSize
  below?: SpacerSize
};

function Spacer({
  above,
  below,
  children,
  className = '',
  ...props
}: SpacerProps) {
  return (
    <div
      {...props}
      className={classnames(styles.spacer, className, {
        // Top spacer
        [styles.xsAbove]: above === SpacerSize.XS,
        [styles.smAbove]: above === SpacerSize.SM,
        [styles.msAbove]: above === SpacerSize.MS,
        [styles.mdAbove]: above === SpacerSize.MD,
        [styles.lgAbove]: above === SpacerSize.LG,
        [styles.xlAbove]: above === SpacerSize.XL,
        [styles.xxlAbove]: above === SpacerSize.XXL,

        // Bottom spacer
        [styles.xsBelow]: below === SpacerSize.XS,
        [styles.smBelow]: below === SpacerSize.SM,
        [styles.msBelow]: below === SpacerSize.MS,
        [styles.mdBelow]: below === SpacerSize.MD,
        [styles.lgBelow]: below === SpacerSize.LG,
        [styles.xlBelow]: below === SpacerSize.XL,
        [styles.xxlBelow]: below === SpacerSize.XXL,
      })}
    >
      {children}
    </div>
  );
}

export default Spacer;
